import { render, staticRenderFns } from "./DragDropUpload.vue?vue&type=template&id=62c78299&scoped=true"
import script from "./DragDropUpload.vue?vue&type=script&lang=js"
export * from "./DragDropUpload.vue?vue&type=script&lang=js"
import style0 from "./DragDropUpload.vue?vue&type=style&index=0&id=62c78299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c78299",
  null
  
)

export default component.exports